import { render, staticRenderFns } from "./new-book-detail.vue?vue&type=template&id=ba0e3db4&scoped=true&"
import script from "./new-book-detail.vue?vue&type=script&lang=js&"
export * from "./new-book-detail.vue?vue&type=script&lang=js&"
import style0 from "./new-book-detail.vue?vue&type=style&index=0&id=ba0e3db4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0e3db4",
  null
  
)

export default component.exports